import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Typography, TextField, Avatar, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from 'react-router-dom';


const MainSocialCommentsReplyPage = () => {
const [comment, setComment] = useState(null);
const history = useHistory();
const [title, setTitle] = useState('');
const [open, setOpen] = useState(false);
const [content, setContent] = useState('');
const [replyText, setReplyText] = useState("");
const [replyChain, setReplyChain] = useState([]);

const { id, commentId } = useParams();
const [mainSocialPost, setMainSocialPost] = useState(null);


useEffect(() => {
  axios.get(`/mainSocialPost/${id}`)
    .then(res => setMainSocialPost(res.data))
    .catch(err => console.error("Error loading bill", err));
}, [id]);



/*
useEffect(() => {
 const fetchComment = async () => {
   try {
     const res = await axios.get(`/mainSocialPost/${id}/commentReplies/${commentId}`);
     setComment(res.data);
   } catch (err) {
     console.error("Error fetching comment:", err);
   }
 };


 fetchComment();
}, [commentId]);
*/
/*useEffect(() => {
  const fetchContext = async () => {
    try {
      const res = await axios.get(
        `/mainSocialPost/${id}/commentContext/${commentId}`
      );
      setReplyChain(res.data.chain);
      setComment(res.data.current);
    } catch (err) {
      console.error("Error loading comment context", err);
    }
  };

  fetchContext();
}, [id, commentId]);*/
const location = useLocation();
const source = location.state?.source;

const [isLoadingReplies, setIsLoadingReplies] = useState(false);

// Pagination stored in refs — never captured stale in observer closures
const cursorRef = useRef(null);
const hasMoreRef = useRef(true);
const isFetchingRef = useRef(false);
const abortRef = useRef(null);

// ── Stable navigation callbacks — safe to pass to React.memo children ──────
const handleNavigate = useCallback((targetId) => {
  history.push(`/mainSocial/${id}/comments/${targetId}`, { source });
}, [history, id, source]);

// ── Core fetch — reads cursor from ref, never from a stale closure ─────────
  const fetchReplies = useCallback(async (overrideCursor) => {
    if (isFetchingRef.current || !hasMoreRef.current) return;

    abortRef.current?.abort();
    abortRef.current = new AbortController();
    isFetchingRef.current = true;
    setIsLoadingReplies(true);

    // undefined means "use whatever cursorRef holds right now"
    const cursorToUse = overrideCursor !== undefined ? overrideCursor : cursorRef.current;

    try {
      const res = await axios.get(
        `/mainSocialPost/${id}/commentContext/${commentId}`,
        {
          params: { cursor: cursorToUse ?? undefined, limit: 10 },
          signal: abortRef.current.signal,
        }
      );

      if (!cursorToUse) {
        // Initial load
        setReplyChain(res.data.chain);
        setComment(res.data.current);
      } else {
        // Append page
        setComment(prev => prev
          ? { ...prev, replies: [...prev.replies, ...res.data.current.replies] }
          : prev
        );
      }

      // Write to refs synchronously — observer always reads current values
      cursorRef.current = res.data.nextCursor;
      hasMoreRef.current = res.data.hasMore;

    } catch (err) {
      if (axios.isCancel(err) || err.name === "CanceledError") return;
      console.error("Fetch replies failed", err);
    } finally {
      isFetchingRef.current = false;
      setIsLoadingReplies(false);
    }
  }, [id, commentId]);

  // ── Reset + initial load whenever route params change ─────────────────────
  useEffect(() => {
    cursorRef.current = null;
    hasMoreRef.current = true;
    isFetchingRef.current = false;
    setComment(null);
    setReplyChain([]);
    fetchReplies(null);
    return () => abortRef.current?.abort();
  }, [id, commentId, fetchReplies]);

  // ── IntersectionObserver on a SEPARATE sentinel div, not the last card ─────
  // This is what makes click + observer mutually exclusive at the DOM level.
  const observerRef = useRef();
  const sentinelRef = useCallback(node => {
    if (observerRef.current) observerRef.current.disconnect();
    if (!node) return;
    observerRef.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMoreRef.current && !isFetchingRef.current) {
        fetchReplies(undefined); // reads cursorRef.current internally
      }
    }, { rootMargin: "300px" });
    observerRef.current.observe(node);
  }, [fetchReplies]);
/*
const [cursor, setCursor] = useState(null);
const [loading, setLoading] = useState(false);
const [hasMore, setHasMore] = useState(true);
const isFetchingRef = useRef(false);

const fetchReplies = async (overrideCursor = cursor) => {
  if (loading || !hasMore || isFetchingRef.current) return;

  try {
    isFetchingRef.current = true;
    setLoading(true);

    const res = await axios.get(
      `/mainSocialPost/${id}/commentContext/${commentId}`,
      {
        params: { cursor: overrideCursor, limit: 5 }
      }
    );

    // only set chain + current ON FIRST LOAD
    if (!overrideCursor) {
      setReplyChain(res.data.chain);
      setComment(res.data.current);
    } else {
      setComment(prev => ({
        ...prev,
        replies: [...(prev.replies || []), ...res.data.current.replies]
      }));
    }

    setCursor(res.data.nextCursor);
    setHasMore(res.data.hasMore);

  } catch (err) {
    console.error("Fetch replies failed", err);
  } finally {
    setLoading(false);
    isFetchingRef.current = false;
  }
};

useEffect(() => {
  setCursor(null);
  setHasMore(true);
  fetchReplies(null);
}, [id, commentId]);

const observer = useRef();

const lastReplyRef = useCallback(node => {
  if (loading) return;
  if (observer.current) observer.current.disconnect();

  observer.current = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && hasMore) {
      fetchReplies();
    }
  });

  if (node) observer.current.observe(node);
}, [loading, hasMore]);
*/

const CommentCard = ({ comment }) => (
  <Box
    p={2} // padding inside box
    my={2} // vertical margin between posts
    //onClick={() => history.push(`/mainSocial/${id}/comments/${comment._id}`, { source: source })}
    onClick={() => handleNavigate(comment._id)}
    border="1px solid #ccc" // light grey border
    borderRadius="8px" // rounded corners
    sx={{
      position: "relative",
      maxWidth: 900, // limit width
      mx: "auto", // center horizontally
      my: 2, // vertical spacing between each post
      cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
    }}
  >
    <Box display="flex" alignItems="flex-start" gap={1}>
      <Avatar
        src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
        onClick={(e) => visitProfile(e, comment.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
      />
      <Box>
        <Typography variant="subtitle1" fontWeight="bold"
        onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
        >
          {comment.author?.first_name} {comment.author?.last_name}
        </Typography>
        <Typography variant="body2" color="text.secondary"
        onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
        >
          @{comment.author?.username}
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
          {comment.text}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount ?? 0
                                        } ${comment.replyCount === 1 ? "reply" : "replies"}`}
                                    </Typography>
      </Box>
    </Box>




    {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
        <Button
          size="small"
          variant={comment.replyVoted? "contained" : "outlined"}
          onClick={(e) => {
            e.stopPropagation();
            toggleReplyVote(comment._id);
          }}
        >
          ▲ {comment.replyVoted ? "Unvote" : "Upvote"}
        </Button>

        <Typography variant="body2">
          {comment.replyUpvotes ?? 0} upvotes
        </Typography>
    </Box>*/}
    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {comment.replyVoted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleReplyVote(comment._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(comment._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                   </Box>
  </Box>
);

const handleReplySubmit = async () => {
  if (!replyText.trim()) return;

  try {
    const res = await axios.post(`/comments/${comment._id}/reply`, {
      text: replyText,
      topic: mainSocialPost.topic,
      topicType: mainSocialPost.topicType,
    });

    // Just refetch comments (single source of truth)
    //const commentsRes = await axios.get(
    //  `/mainSocialPost/${mainSocialPost._id}/comments`
    //);

    //setComments(commentsRes.data);
    const commentRes = await axios.get(
        `/mainSocialPost/${id}/commentContext/${commentId}`
      );
      setReplyChain(commentRes.data.chain);
      setComment(commentRes.data.current);
    setReplyText("");
  } catch (err) {
    console.error("Reply error", err);
  }
};

const toggleVote = async (postId) => {
       try {
           const res = await axios.post(`/post/${postId}/upvote`);
           const { upvotes, voted } = res.data;


           setMainSocialPost(prevCase => ({
               ...prevCase,
               upvotes,
               voted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };

const handleSubmit = async () => {
  try {
    await axios.post('/api/govPosts', {
      title,
      content,
      topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
    });
    setOpen(false);
    setTitle('');
    setContent('');
    alert('Post created!');
  } catch (err) {
    console.error('Failed to create post', err);
  }
};




const toggleCommentVote = async (commentId) => {
      try {
           // hit backend endpoint that toggles a vote
          const res = await axios.post(`/mainSocialPostComments/${commentId}/upvote`);


          setComment(prev => ({
              ...prev,
              upvotes: res.data.upvotes,
              voted: res.data.voted
          }));
       } catch(err) {
          console.error("Vote error", err);
      }
  };
  /*
      // Recursively update a reply at any depth
  function updateReplyRecursive(replies, replyId, newData) {
    return (replies || []).map((r) => {
      if (r._id === replyId) {
        return { ...r, ...newData }; // update this reply
      }
      return {
        ...r,
        replies: updateReplyRecursive(r.replies, replyId, newData), // recurse
      };
    });
  }




  const toggleReplyVote = async (replyId) => {
    try {
      const res = await axios.post(`/mainSocialPost/${id}/commentReplies/${replyId}/upvote`);
      const { replyUpvotes, replyVoted } = res.data;




      setComment((prev) => {
        if (!prev) return prev;


        // Case A: this comment itself is the reply
        if (prev._id === replyId) {
          return {
            ...prev,
            replyUpvotes,
            replyVoted,
          };
        }


        // Case B: it's somewhere in prev.replies (any depth)
        return {
          ...prev,
          replies: updateReplyRecursive(prev.replies, replyId, {
            replyUpvotes,
            replyVoted,
          }),
        };
      });
    } catch (err) {
      console.error("Reply vote error", err);
    }
  };
      console.log(comment);
      */
  const updateReplyChainRecursive = (nodes = [], id, updates) => {
    let changed = false;

    const next = nodes.map((n) => {
      if (n._id === id) {
        changed = true;
        return { ...n, ...updates };
      }

      const updatedReplies = updateReplyChainRecursive(n.replies, id, updates);
      if (updatedReplies !== n.replies) {
        changed = true;
        return { ...n, replies: updatedReplies };
      }

      return n;
    });

    return changed ? next : nodes;
  };

  const updateReplyRecursive = (replies = [], replyId, updates) => {
    return replies.map((r) => {
      if (r._id === replyId) {
        return { ...r, ...updates };
      }

      return {
        ...r,
        replies: updateReplyRecursive(r.replies, replyId, updates),
      };
    });
  };

  const toggleReplyVote = async (replyId) => {
    try {
      const res = await axios.post(
        `/mainSocialPost/${id}/commentReplies/${replyId}/upvote`
      );

      const { replyUpvotes, replyVoted } = res.data;

      setComment((prev) => {
        if (!prev) return prev;

        // Case A: current focused comment is the reply
        if (prev._id === replyId) {
          return {
            ...prev,
            replyUpvotes,
            replyVoted,
          };
        }

        // Case B: reply exists somewhere in the chain
        return {
          ...prev,
          replies: updateReplyRecursive(prev.replies, replyId, {
            replyUpvotes,
            replyVoted,
          }),
        };
      });

      setReplyChain((prev) =>
        updateReplyChainRecursive(prev, replyId, {
          replyUpvotes,
          replyVoted,
        })
      );
    } catch (err) {
      console.error("Reply vote error", err);
    }
  };

  /*const handleReplySubmit = async () => {
    if (!replyText.trim()) return;


    try {
      const res = await axios.post(`/mainSocialPost/comments/${comment._id}/replies`, {
        text: replyText,
        topic: mainSocialPost.topic,
        topicType: mainSocialPost.topicType,
      });




     setComment(prev => ({
      ...prev,
      replies: [
          ...(prev.replies || []), res.data]
      }));




     setReplyText("");
    } catch (err) {
      console.error("Reply error", err);
    }
  };*/

  //console.log(comment);
if (!comment) return <Typography>Loading...</Typography>;


const isTopLevel = mainSocialPost?.comments?.some(c => c._id === comment._id);


function addReplyRecursive(comment, targetId, newReply) {
  // if this comment/reply matches the target, append the new reply
  if (comment._id === targetId) {
    return {
      ...comment,
      replies: [...(comment.replies || []), newReply]
    };
  }


  // otherwise, dive into nested replies
  return {
    ...comment,
    replies: comment.replies?.map(r => addReplyRecursive(r, targetId, newReply)) || []
  };
}

const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };
/*
const handleReplyCommentSubmit = async (targetId) => {
if (!replyText.trim()) return;
try {
 const res = await axios.post(`/mainSocialPost/${id}/replyComments/${targetId}/replies`, {
   text: replyText,
   topic: mainSocialPost.topic,
   topicType: mainSocialPost.topicType,
 });


 const newReply = res.data;


 // update the state recursively
 setComment(prev => addReplyRecursive(prev, targetId, newReply));


 setReplyText("");
} catch (err) {
 console.error("Reply error", err);
}
};*/

if (!mainSocialPost) {
  return <div>Loading...</div>; 
}


//console.log(comment);
//console.log(mainSocialPost);
    let universityLogo = null;
    if (mainSocialPost.topic) {
        if (mainSocialPost.topic === "ucla" || mainSocialPost.topic === "ucla/majors/math") {
            universityLogo = "/uploads/universityLogos/logo_UCLA_blue_boxed.png";
        } else if (mainSocialPost.topic === "stanford") {
            universityLogo = "/uploads/universityLogos/stanford_logo.png";
        } 
    }

    //const location = useLocation();
   //const source = location.state?.source;
    const navItems = !mainSocialPost?.topic
    ? [
        /*{
            label: "Popular",
            path: "/page1/a",
            matchPaths: ["/page1/a"]
        },
        {
            label: "Following",
            path: "/page1/b",
            matchPaths: ["/page1/b", "/mainSocial"]
        },*/
        {
            label: "Popular",
            path: "/mainsocial/popular",
            matchPaths:
            source === "popular"
                ? ["/mainsocial/popular", "/mainSocial"]
                : ["/mainsocial/popular"]
        },
        {
            label: "Following",
            path: "/mainsocial/following",
            matchPaths:
            source === "following"
                ? ["/mainsocial/following", "/mainSocial"]
                : ["/mainsocial/following"]
        },
        {
            label: "Academia",
            path: "/mainsocial/academia/popular",
            matchPaths: ["/mainsocial/academia/popular"]
        },
        {
            label: "Topic Threads",
            path: "/mainsocial/topicthreads",
            matchPaths: ["/mainsocial/topicthreads"]
        },
        {
            label: "Photos",
            path: "/mainsocial/photos/following",
            matchPaths: ["/photos"]
        },
        {
            label: "Videos",
            path: "/mainsocial/videos/following",
            matchPaths: ["/videos"]
        }
        ]
    : [];

    const navUniversityItems =
        mainSocialPost?.topicType === "university"
            ? [
                {
                    label: "Popular Academia",
                    path: "/mainsocial/academia/popular",
                    matchPaths: ["/mainsocial/academia/popular"]
                },
                {
                    label: "University",
                    path: "/mainsocial/academia/university",
                    matchPaths: [
                        "/mainsocial/academia/university",
                        "/mainSocial"
                    ]
                },
                {
                    label: "Academic Subjects",
                    path: "/mainsocial/academia/academicsubjects",
                    matchPaths: ["/mainsocial/academia/academicsubjects"]
                }
            ]
    : [];
    const navAcademicSubjectItems =
        mainSocialPost?.topicType === "academicSubject"
            ? [
                {
                    label: "Popular Academia",
                    path: "/mainsocial/academia/popular",
                    matchPaths: ["/mainsocial/academia/popular"]
                },
                {
                    label: "University",
                    path: "/mainsocial/academia/university",
                    matchPaths: [
                        "/mainsocial/academia/university",
                    ]
                },
                {
                    label: "Academic Subjects",
                    path: "/mainsocial/academia/academicsubjects",
                    matchPaths: ["/mainsocial/academia/academicsubjects","/mainSocial"]
                }
            ]
    : [];


   const isActive = (item) => {
       return item.matchPaths.some((match) =>
           location.pathname.startsWith(match)
       );
       };


       const getButtonStyles = (item) => {
       const active = isActive(item);


       return {
           padding: "6px 12px",
           borderColor: active ? "#1f1f1f" : "#333333",
           color: active ? "#1f1f1f" : "#333333",
           backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
           fontWeight: active ? 600 : 500,
           transition: "all 0.15s ease",
           "&:hover": {
           borderColor: "black",
           color: "black",
           backgroundColor: "rgba(0,0,0,0.12)"
           }
       };
   };

    const navThreadItems =
        mainSocialPost?.topicType === "thread"
            ? [
                { label: "Popular", path: "/mainsocial/popular" },
                { label: "Following", path: "/mainsocial/following" },
                { label: "Academia", path: "/mainsocial/academia/popular" },
                { label: "Topic Threads", path: "/mainsocial/topicthreads", matchPaths: ["/mainsocial/topicthreads", "/mainSocial"] },
                { label: "Photos", path: "/mainsocial/photos/following" },
                { label: "Videos", path: "/mainsocial/videos/following" }
            ]
    : [];

    const getThreadButtonStyles = (item) => {
      //const active = location.pathname.startsWith(path);
      const active = item.matchPaths
        ? item.matchPaths.some(path => location.pathname.startsWith(path))
        : location.pathname.startsWith(item.path);

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
return (
  <div
          style={{
              padding: '20px',
              backgroundColor: '#FFFDF8',
              minHeight: '100vh',  // ensures it covers the full viewport height
              boxSizing: 'border-box', // ensures padding doesn't affect layout
          }}
      >




          <div style={{ width: '200px' }}></div>

        {mainSocialPost?.topicType === "university" && (
            <Box
                sx={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                backgroundColor: "#FFFDF8",
                py: 2
                }}
            >
              <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                >
                {navUniversityItems.map((item) => (
                    <Button
                    key={item.path}
                    variant="outlined"
                    sx={getButtonStyles(item)}
                    onClick={() => history.push(item.path)}
                    >
                    {item.label}
                    </Button>
                ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
            )}

        {mainSocialPost?.topicType === "academicSubject" && (
            <Box
                sx={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                backgroundColor: "#FFFDF8",
                py: 2
                }}
            >
              <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                >
                {navAcademicSubjectItems.map((item) => (
                    <Button
                    key={item.path}
                    variant="outlined"
                    sx={getButtonStyles(item)}
                    onClick={() => history.push(item.path)}
                    >
                    {item.label}
                    </Button>
                ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
            )}

        {mainSocialPost?.topicType === "thread" && (
            <Box
                sx={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                backgroundColor: "#FFFDF8",
                py: 2
                }}
            >
              <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                >
                {navThreadItems.map((item) => (
                    <Button
                    key={item.path}
                    variant="outlined"
                    sx={getThreadButtonStyles(item)}
                    onClick={() => history.push(item.path)}
                    >
                    {item.label}
                    </Button>
                ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
            )}

        {mainSocialPost?.topicType === "academicSubject" && (
            <Box 
                display="flex" 
                onClick={() => history.push(`/mainsocial/academia/academicsubjects/${mainSocialPost?.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <Typography variant="h4">c/{mainSocialPost?.topic}</Typography>
            </Box>
        )}
        {mainSocialPost?.topicType === "thread" && (
            <Box 
                display="flex" 
                onClick={() => history.push(`/mainsocial/topicthreads/${mainSocialPost?.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <Typography variant="h4">c/{mainSocialPost?.topic}</Typography>
            </Box>
        )}
        {/*{mainSocialPost?.topic ? (
            <Box 
                display="flex" 
                onClick={() => history.push(`/topics/${mainSocialPost.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <img 
                    src={universityLogo} 
                    style={{
                        maxWidth: "300px",   // limit width
                        height: "auto",      // keep proportions
                        objectFit: "contain" // avoid stretching
                    }}
                />
            </Box>
          ) : (*/}
           {mainSocialPost?.topicType === "university" && (
            <Box 
                display="flex" 
                onClick={() => history.push(`/mainsocial/academia/university/${mainSocialPost.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <Typography variant="h4">
                    c/{mainSocialPost.topic
                        .split("/")
                        .filter(segment => segment !== "majors" && segment !== "clubs")
                        .join("/")}
                </Typography>
            </Box>
            )}
        
          {mainSocialPost?.topicType != "university" && mainSocialPost?.topicType != "academicSubject" && mainSocialPost?.topicType != "thread" && (
          <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: "#FFFDF8",
                    py: 2
                }}
            >
              <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                >
                    {navItems.map((item) => (
                    <Button
                        key={item.path}
                        variant="outlined"
                        sx={getButtonStyles(item)}
                        onClick={() => history.push(item.path)}
                    >
                        {item.label}
                    </Button>
                    ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
        )}

        {/*{mainSocialPost?.topic ? (
            <Box 
                display="flex" 
                onClick={() => history.push(`/topics/${mainSocialPost.topic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <img 
                    src={universityLogo} 
                    style={{
                        maxWidth: "300px",   // limit width
                        height: "auto",      // keep proportions
                        objectFit: "contain" // avoid stretching
                    }}
                />
            </Box>
          ) : (


          <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={2}
              flexWrap="wrap"
              sx={{
                  mt: 4,
                  mb: 4,
              }}
                  >
                    <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/page1/a')}
                  >
                      Popular
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/page1/b')}
                  >
                      Following
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/page1/c')}
                  >
                      Academia
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/page1/d')}
                  >
                      Topic Threads
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/photos')}
                  >
                      Photos
                  </Button>
                  <Button
                      variant="outlined"
                      sx={{
                          padding: "6px 12px",
                          borderColor: "#333333",
                          color: "#333333",     
                          backgroundColor: "transparent",
                          '&:hover': {
                              borderColor: "black",
                              color: "black",
                              backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                          },
                      }}
                      onClick={() => history.push('/videos')}
                  >
                      Videos
                  </Button>
        </Box>
)}*/}
<Box
            p={2} // padding inside box
            my={2} // vertical margin between posts
            onClick={() => history.push(`/post/${mainSocialPost._id}/comments`, { source: source })}
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            sx={{
                position: "relative",
                maxWidth: 900, // limit width
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
                cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
            }}
      >
        {/** Root Post */}
        <Box display="flex" alignItems="flex-start" gap={1}>
                       <Avatar
                           src={mainSocialPost.author?.profileImageUrl || '/default-avatar.jpg'}
                           alt={`${mainSocialPost.author?.first_name || ''} ${mainSocialPost.author?.last_name || ''}`}
                           onClick={(e) => visitProfile(e, mainSocialPost.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
                       />
                       <Box>
                           <Typography variant="subtitle1" fontWeight="bold"
                           onClick={(e) => visitProfile(e, mainSocialPost.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                           >
                           {mainSocialPost.author?.first_name && mainSocialPost.author?.last_name
                               ? `${mainSocialPost.author.first_name} ${mainSocialPost.author.last_name}`
                               : 'Unknown Name'}
                           </Typography>
                           <Typography variant="body2" color="text.secondary"
                           onClick={(e) => visitProfile(e, mainSocialPost.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                           >
                           @{mainSocialPost.author?.username || 'unknown'}
                           </Typography>



                           <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                               {mainSocialPost.content}
                           </Typography>


            
                           <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                            >
                                {`${new Date(mainSocialPost.created_at).toLocaleString()}, ${
                                    mainSocialPost.commentCount
                                } ${mainSocialPost.commentCount === 1 ? 'reply' : 'replies'}`}
                            </Typography>


                       </Box>
                   </Box>
                   {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                       <Button
                           size="small"
                           variant={mainSocialPost.voted ? "contained" : "outlined"}
                           //onClick={() => toggleVote(post._id)}
                           onClick={(e) => {
                               e.stopPropagation();
                               toggleVote(mainSocialPost._id)}
                           }
                       >
                           ▲ {mainSocialPost.voted ? "Unvote" : "Upvote"}
                       </Button>
                       <Typography variant="body2">{mainSocialPost.upvotes} upvotes</Typography>
                   </Box>*/}
                   <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {mainSocialPost.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(mainSocialPost._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(mainSocialPost._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{mainSocialPost.upvotes} Power Votes</Typography>
                   </Box>
                </Box>
        {/* Reply chain */}
        {replyChain.map((c) => (
          <CommentCard
            key={c._id}
            comment={c}
          />
        ))}
  <Box
            p={2} // padding inside box
            my={2} // vertical margin between posts
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            sx={{
                position: "relative",
                maxWidth: 900, // limit width
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
            }}
      >
    {/* original comment */}
    <Box display="flex" alignItems="flex-start" gap={1}>
      <Avatar
        src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
        onClick={(e) => visitProfile(e, comment.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
      />
      <Box>
        <Typography variant="subtitle1" fontWeight="bold"
        onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
        >
          {comment.author?.first_name} {comment.author?.last_name}
        </Typography>
        <Typography variant="body2" color="text.secondary"
        onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
        >
          @{comment.author?.username}
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
          {comment.text}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
          {`${new Date(comment.created_at).toLocaleString()}, ${
            comment.replyCount
          } ${comment.replyCount === 1 ? "reply" : "replies"}`}
        </Typography>
      </Box>
    </Box>




    {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                          <Button
                              size="small"
                              variant={
                                isTopLevel
                                  ? (comment.voted ? "contained" : "outlined")
                                  : (comment.replyVoted ? "contained" : "outlined")
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isTopLevel) {
                                  toggleCommentVote(comment._id);
                                } else {
                                  toggleReplyVote(comment._id);
                                }}
                              }
                          >
                              ▲ {isTopLevel
                                ? (comment.voted ? "Unvote" : "Upvote")
                                : (comment.replyVoted ? "Unvote" : "Upvote")}
                          </Button>
                          <Typography variant="body2">
                            {isTopLevel ? comment.upvotes : comment.replyUpvotes} upvotes
                          </Typography>
                      </Box>*/}
      {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
        <Button
          size="small"
          variant={comment.replyVoted? "contained" : "outlined"}
          onClick={(e) => {
            e.stopPropagation();
            toggleReplyVote(comment._id);
          }}
        >
          ▲ {comment.replyVoted ? "Unvote" : "Upvote"}
        </Button>

        <Typography variant="body2">
          {comment.replyUpvotes ?? 0} upvotes
        </Typography>
    </Box>*/}
    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {comment.replyVoted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleReplyVote(comment._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(comment._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                   </Box>
  </Box>
  {/* Comment Form */}
    <Box
          p={2} // padding inside box
          my={2} // vertical margin between posts
          border="1px solid #ccc" // light grey border
          borderRadius="8px" // rounded corners
          sx={{
              position: "relative",
              maxWidth: 900, // limit width
              mx: "auto", // center horizontally
              my: 2, // vertical spacing between each post
          }}
      >
      <TextField
        fullWidth
        multiline
        rows={2}
        placeholder="Engage in intellectual discourse..."
        value={replyText}
        onChange={(e) => setReplyText(e.target.value)}
      />
      <Button
        variant="outlined"
        sx={{ mt: 1 }}
        onClick={(e) => {
          e.stopPropagation();
          handleReplySubmit();
        }}
      >
        Reply
      </Button>
    </Box>
    {/* replies */}
      {comment.replies.length === 0 && !hasMoreRef.current ? (
          <Typography></Typography>
        ) : (
        comment.replies.map((reply, i) => {
          const isLast = i === comment.replies.length - 1;

          return (
          <Box
            p={2} // padding inside box
            key={reply._id}
            ref={isLast ? sentinelRef : null}
            //onClick={() => history.push(`/mainSocial/${id}/comments/${reply._id}`)}
            //onClick={() => history.push(`/mainSocial/${id}/comments/${reply._id}`, { source: source })}
            onClick={() => handleNavigate(reply._id)}
            my={2} // vertical margin between posts
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            sx={{
                position: "relative",
                maxWidth: 900, // limit width
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "#f9f9f9"
                }
            }}
      >
          <Box display="flex" alignItems="flex-start" gap={1}>
                          <Avatar
                              src={reply.author?.profileImageUrl || '/default-avatar.jpg'}
                              alt={`${reply.author?.first_name || ''} ${reply.author?.last_name || ''}`}
                              onClick={(e) => visitProfile(e, reply.author?._id)}
                              sx={{ 
                                width: 62, 
                                height: 62,
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: "#d9e4f0",
                                }, 
                                }}
                          />
                          <Box>
                              <Typography variant="subtitle1" fontWeight="bold"
                              onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                              >
                              {reply.author?.first_name && reply.author?.last_name
                                  ? `${reply.author.first_name} ${reply.author.last_name}`
                                  : 'Unknown Name'}
                              </Typography>
                              <Typography variant="body2" color="text.secondary"
                              onClick={(e) => visitProfile(e, reply.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                              >
                              @{reply.author?.username || 'unknown'}
                              </Typography>




                              {/* Post content */}
                              <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                  {reply.text}
                              </Typography>




                              {/* Date */}
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                              >
                                {`${new Date(reply.created_at).toLocaleString()}, ${
                                  reply.replyCount ?? 0
                                } ${reply.replyCount === 1 ? "reply" : "replies"}`}
                              </Typography>




                          </Box>
                      </Box>
            
            {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                          <Button
                              size="small"
                              variant={reply.replyVoted ? "contained" : "outlined"}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(reply._id)}
                              }
                          >
                              ▲ {reply.replyVoted ? "Unvote" : "Upvote"}
                          </Button>
                          <Typography variant="body2">{reply.replyUpvotes} upvotes</Typography>
                      </Box>*/}
              <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {reply.replyVoted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleReplyVote(reply._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(reply._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{reply.replyUpvotes} Power Votes</Typography>
                   </Box>
          </Box>
        );
      })
    )}
  </div>
);
};




export default MainSocialCommentsReplyPage;
